import { useReducedMotion } from 'motion/react';

// Motion wrappers (DESIGN.md 11, frontend-handoff 9). Every animation is
// transform/opacity only and collapses to instant under prefers-reduced-motion.
// The pending-judgment pulse is a CSS keyframe (see app.css), the only perpetual loop.

const EASE_OUT: [number, number, number, number] = [0.16, 1, 0.3, 1];

export interface EnterProps {
  initial: false | { opacity: number; y: number };
  animate: { opacity: number; y: number };
  transition?: { duration: number; delay?: number; ease: [number, number, number, number] };
}

export function useScreenEnter(): EnterProps {
  const reduce = useReducedMotion();
  if (reduce) return { initial: false, animate: { opacity: 1, y: 0 } };
  return {
    initial: { opacity: 0, y: 8 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.22, ease: EASE_OUT },
  };
}

export function useRevealStagger(i: number): EnterProps {
  const reduce = useReducedMotion();
  if (reduce) return { initial: false, animate: { opacity: 1, y: 0 } };
  return {
    initial: { opacity: 0, y: 4 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.4, delay: 0.06 * i, ease: EASE_OUT },
  };
}
